<template>
	<router-link
		v-if="to"
		tag="p"
		:to="to"
		:class="['tab__item', { active__item: active }]"
	>
		<strong> {{ text.toUpperCase() }} </strong>
	</router-link>
	<div
		v-else
		:class="['tab__item', { active__item: active }]"
		@click="emit('click')"
	>
		<strong> {{ text.toUpperCase() }} </strong>
	</div>
</template>

<script setup>
import { toRefs } from 'vue'

const emit = defineEmits(['click'])

const props = defineProps({
	text: {
		type: String,
	},
	active: {
		type: Boolean,
		default: false,
	},
	to: {
		type: [String, Object],
		required: false,
	},
})

const { text, active } = toRefs(props)
</script>

<style scoped>
.active__item::after {
	content: '';
	background: var(--color-base-secondary);
	display: block;
	height: 2px;
}

.tab__item {
	margin: 0;
	width: 33.33%;
	text-align: center;
	cursor: pointer;
}

.tab__item.active__item strong {
	color: var(--color-base-secondary);
}

.tab__item strong:hover {
	color: var(--color-base-secondary);
}

.tab__item strong {
	line-height: 3;
	gap: 0.5rem;
	display: flex;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	color: var(--color-cinza-escuro);
}
</style>
